export const DEFAULT_FONT_SIZE_SCALE = 100;
export const MAXIMUM_FONT_SIZE_SCALE = 200;
export const SCALE_STEP = 50;

export const DEFAULT_ACCESSIBILITY_SCOPE = 'mclass-default';

export const ZOOM_CONFIG = 'config.zoom';
export const IS_MAZE_UNTIMED = 'config.isMazeUntimed';
export const IS_CAPTIONS_ENABLED = 'config.isCaptionsEnabled';
export const IS_ANIMATION_VISUAL_REDUCED = 'config.isAnimationVisualReduced';
export const CAPTIONS = 'captions';
export const OWL_ANIMATION = 'owlAnimation';
